import React from 'react';
import PropTypes from 'prop-types';

import { HamburgerButtonStyled, HamburgerButtonInner } from './HamburgerButton.styled';

const HamburgerButton = ({ onClick, modifiers }) => (
  <HamburgerButtonStyled modifiers={modifiers} onClick={onClick}>
    <HamburgerButtonInner>
      <span>Open Navigation</span>
    </HamburgerButtonInner>
  </HamburgerButtonStyled>
);

HamburgerButton.propTypes = {
  onClick: PropTypes.func,
  modifiers: PropTypes.oneOf(['', 'active']),
};

HamburgerButton.defaultProps = {
  modifiers: '',
  onClick: () => { },
};

export default HamburgerButton;
